<template>
  <v-autocomplete
    hide-details="auto"
    :items="Guest"
    :loading="loading"
    v-model="selectedGuest"
    item-text="name"
    item-value="id"
    label="Guest"
    clearable
    outlined
    dense
    @change="emitInput"
    :search-input.sync="searchGuest"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    Guest: [],
    selectedGuest: null,
    searchGuest:null,
    loading:false
  }),
  methods: {
    emitInput() {
      this.$emit("input", this.selectedGuest);
    },
    getShopByQuery(query = "") {
        
      this.loading = true;
      this.$store
        .dispatch("guest/GetGuests", {
          query: query,
          status: "active",
        })
        .then((res) => {
          this.Guest = res.data.data
          this.loading = false;

        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
     searchGuest: {  
    handler(val) {
      this.getShopByQuery(val);
    },
    immediate: true, 
  },
    clear: {
      handler(val) {
        this.selectedGuest = null;
      },
      deep: true,
    },
    searchShop: {
      handler(val) {
        this.getShopByQuery(val);
      },
      deep: true,
    },
  },
  created(){
    this.getShopByQuery()
  }
};
</script>